import React, { ReactNode } from 'react';

interface IOSHeaderActionsProps {
  children: ReactNode;
}

/**
 * iOS 风格的头部操作区域组件
 * 用于包装右侧的操作按钮
 */
export const IOSHeaderActions: React.FC<IOSHeaderActionsProps> = ({ children }) => {
  return (
    <>{children}</>
  );
};
